import { Card, CardBody, Col, Container, Row } from "reactstrap";
import CreateNewProjectForm from "./CreateNewProjectForm";
import { Breadcrumbs } from "../../../AbstractElements";
import { Project, ProjectCreate } from "../../../Constant";

const CreateProjectContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={ProjectCreate} parent={Project} title={ProjectCreate} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <CreateNewProjectForm />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreateProjectContainer;
